<script>
import toolbarMixin from "../../extensions/mixins/mixin-toolbar";
import ErrorBoundary from "@/components/core/error-boundary";
import AdManager from "@/extensions/managers/ad-manager";
import PmGalleryLayout from "./gallery-layout";
const defaultGrid = 2;

export default {
    mixins: [toolbarMixin],

    components: {
        ErrorBoundary,
        PmGalleryLayout,
    },

    data: () => ({
        grid: defaultGrid,
        currentView: "all",
    }),

    watch: {
        currentView() {
            this.updateToolbar();
        }
    },

    beforeRouteEnter(to, from, next) {
        if (window.packageName && !['com.denticalc.photos', 'com.denticalc.4in1'].includes(window.packageName)) return(next({name: "home"}));
        if (from && typeof from.name === "string" && !from.name.includes('gallery')) {
            AdManager.logRouteView('gallery');
        }
        return next();
    },

    created() {
        this.registerBusEvent('openGallery', (id) => {
            window.prevGalleryId = id;
            this.currentView = 'gallery';
        });
    },

    mounted() {
        if (window["packageName"] === "com.denticalc.photos") {
            window.app.notifyFlutterMounted();
        }
    },

    toolbar() {
        const items = [];

        items.push({
            mdi: "image-outline",
            // active: this.$router.currentRoute.name === "gallery" || this.$router.currentRoute.name === "gallery-page",
            active: this.currentView === "all" || this.currentView === "gallery",
            text: app.$t('photos.title'),
            callback: () => {
                //this.$router.push("/gallery").catch(_ => {});
                this.currentView = "all";
            },
        });

        items.push({
            mdi: "emoticon-happy-outline",
            text: app.$t('photos.before_after'),
            // active: this.$router.currentRoute.name === "gallery-before-after",
            active: this.currentView === "before-after",
            callback: () => {
                // this.$router.push('/gallery-before-after').catch(_ => {});
                this.currentView = "before-after";
            },
        });

        items.push({
            mdi: "heart-outline",
            text: app.$t('photos.favourites'),
            // active: this.$router.currentRoute.name === "gallery-favourites",
            active: this.currentView === "favourites",
            callback: () => {
                // this.$router.push('/gallery-favourites').catch(_ => {});
                this.currentView = "favourites";
            },
        });

        items.push({
            back: true,
            //disabled: this.currentView === "all",
            callback: () => {
                //this.currentView = 'all';
                //alert(this.$router.currentRoute.name);
                // if (window.prevGalleryId > 0) this.currentView = 'all';
                if (this.currentView !== 'all') this.currentView = 'all';
                else this.$router.push("/");
            },
        });

        return ([items]);
    },
}
</script>
